
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';
import { PeticaoTese } from '@app/models/peticao-tese.model';

@Injectable()
export class PeticaoTeseService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }
  gravar(documento: PeticaoTese): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'peticao/teses', documento).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `peticao/teses/${id}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `peticao/teses/${id}`);
  }

  // obterTodos() {
  //   return this.http.get(this.URL_API + "PeticaoTese")
  // }

  obterLista(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http
      .get<any>(this.URL_API + `peticao/teses/lista/?descricao=${descricao}&pagina=${pagina}`, { headers: { meta: ['search'] }});
  }

}
